
import { Component, Watch, Prop } from "vue-property-decorator";
import { GroupAdvancedSearchQuery, GroupAdvancedSearchCheckboxDropdownOptions, CustomFieldSearchQuery } from "@/types/sv-data/groups/AreaNode";
import { Action, State, namespace, Getter } from 'vuex-class';
import { TimeZone, FeaturesList } from '@/store/types';
import Vue from 'vue';
import { CustomFieldDto, CustomFieldTableTypes, CustomFieldTypes } from '@/store/custom-fields/types';
import { get } from 'lodash';
import vSelect3 from "vselect3";
import { BModal } from "bootstrap-vue";

const CustomFields = namespace("customFields");

@Component({
	components: {
		"v-select-3": vSelect3
	}
})
export default class AdvancedAreaSearch extends Vue {

	$refs!: {
		modal: BModal
	};

	@Getter("getFeaturesList") featuresList: FeaturesList;

	@Action getTimeZones: () => Promise<void>;
	@State private timeZones: TimeZone[];

	@CustomFields.Action retrieveCustomFields: ({ tableType, live }) => Promise<void>;
	@CustomFields.State areaCustomFields: CustomFieldDto[];

	@Prop({ default: () => { return ["Any"] } }) public requiredPermissions: string[];

	private searchQuery: GroupAdvancedSearchQuery = {
		title: "",
		referenceId: "",
		address: "",
		telephonePrimary: "",
		telephoneSecondary: "",
		telephonePolice: "",
		telephoneFire: "",
		timeZoneId: null,
		customFieldSearchQueries: []
	};

	private checkboxDropdownOptions: GroupAdvancedSearchCheckboxDropdownOptions[] = [
		{ value: null, text: "Please select an option" },
		{ value: true, text: "True" },
		{ value: false, text: "False" },
	];

	private customFieldCheckboxQueries = new Map<string, boolean | null>();

	private customFieldSearchQueries = new Map<string, string>();

	private get isCustomFieldsEnabled(): boolean {
		return get(this.featuresList, ["CustomFields"]);
	}

	public async mounted(): Promise<void> {
		if (this.isCustomFieldsEnabled) {
			await this.retrieveCustomFields({ tableType: CustomFieldTableTypes.Area, live: true });
		}

		await this.getTimeZones();
		if (this.$refs.modal) {
			this.$refs.modal.show();
		}
	}

	public async search(): Promise<void> {
		if (this.isCustomFieldsEnabled) {
				this.customFieldCheckboxQueries.forEach((value, key) => {
				if (this.customFieldSearchQueries.has(key)) {
					this.customFieldSearchQueries.set(key, value ? value.toString() : "");
				}
			});
			var untrimmedArray = Array.from(this.customFieldSearchQueries.entries(), ([id, searchQuery]) => ({ id, searchQuery }));
		}
		
		this.searchQuery.customFieldSearchQueries = untrimmedArray ?? [] as CustomFieldSearchQuery[];
		this.$emit("advancedSearchQuery", this.searchQuery);
	}

	private get filteredCustomFields(): CustomFieldDto[] {
		return this.areaCustomFields.filter(cf => cf.customFieldTypeId != CustomFieldTypes.Icon);
	}

	@Watch("areaCustomFields")
	private constructCustomFieldQueryMaps(): void {
		if (!this.isCustomFieldsEnabled) {
			return;
		}

		// Create empty queries in a map for each Area Custom Field in tenancy which accept text searches
		this.filteredCustomFields.forEach(item => this.customFieldSearchQueries.set(item.id, ""));

		// Append further queries for all 'checkbox' type Custom Field map values
		let checkboxCustomFields = this.filteredCustomFields.filter(cf => this.isCheckboxCustomField(cf.customFieldTypeId));
		checkboxCustomFields.forEach(checkbox => 
			this.customFieldCheckboxQueries.set(checkbox.id, false)
		);
	}

	private getMapValue(id: string): string {
		return this.customFieldSearchQueries.get(id) || "";
    }

	private updateMap(id: string, query: string): void {
      if (this.customFieldSearchQueries.has(id)) {
        this.customFieldSearchQueries.set(id, query);
      }
	}

	private updateCheckboxValue(id: string, event: GroupAdvancedSearchCheckboxDropdownOptions): void {
    	if (this.customFieldCheckboxQueries.has(id)) {
			this.customFieldCheckboxQueries.set(id, event.value);
		}
	}

	private isCheckboxCustomField(type: number): boolean {
		return type == CustomFieldTypes.Checkbox
	}

	private emitClose(): void {
		this.$emit("close-advanced-search");
	}
}
